import { Subject } from 'rxjs'; 

export class Settings {

    private _theme!: string;
    private _stickyMenuToolbar!: boolean;
    private _rtl!: boolean;
    private _searchPanelVariant!: number;
    private _searchOnBtnClick!: boolean;
    //additional options
    private _mainToolbarFixed!: boolean;
    private _contentOffsetToTop!: boolean;
    private _headerBgImage!: boolean;

    public ChangedSubject = new Subject()

    constructor(theme: string, stickyMenuToolbar: boolean, 
                rtl: boolean, searchPanelVariant: number, searchOnBtnClick: boolean,
                mainToolbarFixed:boolean, contentOffsetToTop:boolean, headerBgImage: boolean,
                loadmore_start: boolean, loadmore_step: number, loadmore_load: boolean,
                loadmore_page: number, loadmore_complete: boolean, loadmore_result: number) {
        this._theme=theme;
        this._stickyMenuToolbar=stickyMenuToolbar;
        this._rtl=rtl;
        this._searchPanelVariant=searchPanelVariant;
        this._searchOnBtnClick=searchOnBtnClick;
        this._mainToolbarFixed=mainToolbarFixed;
        this._contentOffsetToTop=contentOffsetToTop;
        this._headerBgImage=headerBgImage;
        this.loadMore=new LoadMore(loadmore_start, loadmore_step, loadmore_load,
            loadmore_page, loadmore_complete, loadmore_result);
    }

    get flatObject(){
        return {theme:this._theme, 
                stickyMenuToolbar:this._stickyMenuToolbar, 
                rtl:this._rtl,
                searchPanelVariant:this._searchPanelVariant,
                searchOnBtnClick:this._searchOnBtnClick,
                mainToolbarFixed:this._mainToolbarFixed,
                contentOffsetToTop:this._contentOffsetToTop,
                headerBgImage:this._headerBgImage,
                loadmore_start:this.loadMore.start, 
                loadmore_step: this.loadMore.step,
                loadmore_load: this.loadMore.load,
                loadmore_page: this.loadMore.page,
                loadmore_complete:this.loadMore.complete,
                loadmore_result:this.loadMore.result
            }
    }
    set flatObject(o:any){
        if(o.theme) this._theme=o.theme;
        if(o.stickyMenuToolbar) this._stickyMenuToolbar=o.stickyMenuToolbar;
        if(o.rtl) this._rtl=o.rtl;
        if(o.searchPanelVariant) this._searchPanelVariant=o.searchPanelVariant;
        if(o.searchOnBtnClick) this._searchOnBtnClick=o.searchOnBtnClick;
        if(o.mainToolbarFixed) this._mainToolbarFixed=o.mainToolbarFixed;
        if(o.contentOffsetToTop) this._contentOffsetToTop=o.contentOffsetToTop;
        if(o.headerBgImage) this._headerBgImage=o.headerBgImage;
        this.loadMore=new LoadMore(o.loadmore_start, o.loadmore_step, o.loadmore_load,
            o.loadmore_page, o.loadmore_complete, o.loadmore_result);
    }

    get theme(){
        return this._theme;
    }
    set theme(value:string){
        this._theme=value;
        this.ChangedSubject.next(undefined);
    }

    get stickyMenuToolbar(){
        return this._stickyMenuToolbar;
    }
    set stickyMenuToolbar(value:boolean){
        this._stickyMenuToolbar=value;
        this.ChangedSubject.next(undefined);
    }

    get rtl(){
        return this._rtl;
    }
    set rtl(value:boolean){
        this._rtl=value;
        this.ChangedSubject.next(undefined);
    }

    get searchPanelVariant(){
        return this._searchPanelVariant;
    }
    set searchPanelVariant(value:number){
        this._searchPanelVariant=value;
        this.ChangedSubject.next(undefined);
    }

    get searchOnBtnClick(){
        return this._searchOnBtnClick;
    }
    set searchOnBtnClick(value:boolean){
        this._searchOnBtnClick=value;
        this.ChangedSubject.next(undefined);
    }

    get mainToolbarFixed(){
        return this._mainToolbarFixed;
    }
    set mainToolbarFixed(value:boolean){
        this._mainToolbarFixed=value;
        this.ChangedSubject.next(undefined);
    }

    get contentOffsetToTop(){
        return this._contentOffsetToTop;
    }
    set contentOffsetToTop(value:boolean){
        this._contentOffsetToTop=value;
        this.ChangedSubject.next(undefined);
    }

    get headerBgImage(){
        return this._headerBgImage;
    }
    set headerBgImage(value:boolean){
        this._headerBgImage=value;
        this.ChangedSubject.next(undefined);
    }
    
    public loadMore!: LoadMore;
}

export class LoadMore {
    private _start!: boolean;
    private _step!: number;
    private _load!: boolean;
    private _page!: number;
    private _complete!: boolean;
    private _result!: number;

    public ChangedSubject = new Subject()
    
    constructor(start: boolean, step: number, load: boolean, page: number, complete: boolean, result: number){
            this._start=start;
            this._step=step;
            this._load=load;
            this._page=page;
            this._complete=complete;
            this._result=result;
    }

    get start(){
        return this._start;
    }
    set start(value:boolean){
        this._start=value;
        this.ChangedSubject.next(undefined);
    }

    get step(){
        return this._step;
    }
    set step(value:number){
        this._step=value;
        this.ChangedSubject.next(undefined);
    }

    get load(){
        return this._load;
    }
    set load(value:boolean){
        this._load=value;
        this.ChangedSubject.next(undefined);
    }

    get page(){
        return this._page;
    }
    set page(value:number){
        this._page=value;
        this.ChangedSubject.next(undefined);
    }

    get complete(){
        return this._complete;
    }
    set complete(value:boolean){
        this._complete=value;
        this.ChangedSubject.next(undefined);
    }

    get result(){
        return this._result
    }
    set result(value:number){
        this._result=value;
        this.ChangedSubject.next(undefined);
    }
}